import { JobStatus } from '../types/enums/JobStatus.enum';
import { Job } from '../types/Job/Job.type';

export const isJobActive = (job: Job | null) =>
  job?.status?.id === JobStatus.QUEUED || job?.status?.id === JobStatus.IN_PROGRESS;
